import http from '../jslibs/axios/http';

//产品解析 解析列表
export const getAnalysisList= data => (http.get('/v1/cms/ProductAnalysis', data));

//产品解析 新增解析
export const addAnalysis= data => (http.post('/v1/cms/ProductAnalysis', data));

//产品解析 删除解析
export const deleteAnalysis= uuid => (http.delete(`/v1/cms/ProductAnalysis/${uuid}`));

//产品解析 解析详情
export const analysisDetail= uuid => (http.get(`/v1/cms/ProductAnalysis/${uuid}`));

//产品解析 编辑解析
export const editAnalysis= data => (http.put(`/v1/cms/ProductAnalysis/${data.id}`, data));